import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import cookies from '../../../../../CommonFunction/cookies';
import Loader from '../../../../../CommonFunction/Loader';
import { HiShieldCheck } from 'react-icons/hi';
import { showFailed } from '../../../../../CommonFunction/SweetAlert';
import toast from 'react-hot-toast';

const getVerificationParams = (search) => {
    const normalizedSearch = search
    .replace(/^\?/, '')
    .replace(/_(?=(number|code|role)=)/g, '&');
    const params = new URLSearchParams(normalizedSearch);

    return {
        number: params.get('number'),
        code: params.get('code'),
        role: params.get('role'),
    };
};

const WhatsAppVerification = () => {
    const location = useLocation();
    const jwtToken = cookies.get('jwt');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        const verifyWhatsApp = async () => {
            try {
                console.log("STEP 1");
                const { number, code, role } = getVerificationParams(location.search);

                console.log("STEP 2");
console.log(number, code, role);
                if (!number || !code || !role) {
                    throw new Error('Invalid WhatsApp verification link.');
                }

                const headers = {
                    "Content-Type": "application/json",
                };

                if (jwtToken) {
                    headers.Authorization = 'Bearer ' + jwtToken;
                }

                const response = await fetch(
                    `${process.env.REACT_APP_PLATFORM_API_BASE_URL}/${role}/whatsapp/verify-otp`,
                    {
                        method: "POST",
                        headers,
                        body: JSON.stringify({
                            device_id: number,
                            code: code
                        }),
                    }
                );

                const result = await response.json().catch(() => ({}));
                

                if (response.ok && response.status === 200) {
                    toast.success(`WhatsApp Number Verified.`);
                } else {
                    setError(true);
                    showFailed('Failed.',`${result.error || result.message || 'WhatsApp verification failed.'}`)
                    console.error("WhatsApp verification failed:", result.error);
                }
            } catch (error) {
                setError(true);
                showFailed('Failed.',`${error}`)
                console.error("Error during WhatsApp verification:", error);
            } finally {
                setLoading(false);
            }
        };

        verifyWhatsApp();
    }, [jwtToken, location.search]);

    if (loading) {
        // Render a loading indicator here
        return <div><Loader /></div>;
    }

    return (
        <>
            <div className='container mx-auto '>
                <div className='flex justify-center items-center h-[65vh] bg-bgclr8'>
                    <div className='text-center'>
                        {error === true ? (
                            <h1 className='flex md:text-[40px] text-[22px] text-red-500 font-bold'><span className='drop-shadow-lg shadow-black'>WhatsApp Verification Failed.</span></h1>                 
                        ) : (
                            <h1 className='flex md:text-[40px] text-[22px] text-green-600 font-bold'><span className='drop-shadow-lg shadow-black'>WhatsApp Number Verified</span> <HiShieldCheck className='ml-2 mt-2' /></h1>                 
                        )}
                       </div>
                </div>
            </div>
        </>
    )
};

export default WhatsAppVerification;
